import { useCart } from "../../context/CartContext";

export default function CartCount() {
  const { cartCount } = useCart();

  return (
    <span className="absolute -top-2 -right-2 min-w-[20px] h-[20px] px-1 rounded-full bg-[#d7ff4f] text-[#211b33] text-[11px] font-bold flex items-center justify-center border border-white shadow-sm">
      {cartCount}
    </span>
  );
}